import Const from '../Const'
import {observable} from 'mobx'
class OtherState {
}
export const otherState = new OtherState()



// WEBPACK FOOTER //
// ./src/stateClass/OtherState.js